import React from 'react';
import { Dialog, DialogContent, Box, Button } from '@mui/material';
import CloseIcon from '../../../assets/icons/closeIcon.svg';

interface SimpleDialogProps {
  open: boolean;
  onClose: () => void;
  srcImage: string;
  imageHeight?: string;
  srcImage2?: string;
  imageHeight2?: string;
  dialogPadding?: string;
  closeButtonMarginRight?: string;
  closeButtonMarginTop?: string;
}

export const ImageModal = (props: SimpleDialogProps) => {
  const {
    onClose,
    open,
    srcImage,
    imageHeight,
    srcImage2,
    imageHeight2,
    dialogPadding,
    closeButtonMarginRight,
    closeButtonMarginTop
  } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: '400px',
          borderRadius: '0.9375rem',
          p: dialogPadding,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      <Button
        sx={{
          justifyContent: 'end',
          marginRight: closeButtonMarginRight ? closeButtonMarginRight : '0',
          marginTop: closeButtonMarginTop ? closeButtonMarginTop : '0'
        }}
        onClick={handleClose}
        data-testid="image-modal-close-btn"
      >
        <img src={CloseIcon} alt="Close" />
      </Button>
      <DialogContent
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          /* overflow: 'hidden' */
          overflow: 'auto',
          // Firefox scrollbar styling
          scrollbarWidth: 'thin',
          // Webkit scrollbar styling (Chrome, Safari, Edge)
          '&::-webkit-scrollbar': {
            width: '0.5rem'
          },
          '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
            borderRadius: '0.25rem'
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '0.25rem'
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: '#555'
          }
        }}
      >
        <Box
          component="img"
          src={srcImage}
          alt="Sample"
          sx={{
            width: '100%',
            height: imageHeight,
            objectFit: 'contain',
            borderRadius: '0.25rem'
          }}
        />
        {srcImage2 && (
          <Box
            component="img"
            src={srcImage2}
            alt="Sample"
            sx={{
              width: '100%',
              height: imageHeight2,
              objectFit: 'contain',
              borderRadius: '0.25rem',
              paddingTop: '1rem'
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
